import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './materia_prima_familia_utils';

export const useMateriaPrimaFamiliaStore = defineStore('materiaPrimaFamiliaStore', {
  state: () => ({
    entity: 'materia-prima-familia',
    materiaPrimaFamilias: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllfamiliaMaterialHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params, sortBy: 'Descripcion', sort: 'asc' })}`,
      );
      if (result && result.data) {
        this.materiaPrimaFamilias.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async searchMateriaPrimaFamiliaHTTP(query, page = 1, limit = 30) {
      const q = (query ?? '').toString().trim();
      if (q.length < 3) return [];
      const qs = getParamsUrl({
        page,
        limit,
        sortBy: 'Descripcion',
        sort: 'asc',
        Descripcion: q,
        Activo: true,
      });
      const res = await api.get(`/${this.entity}?${qs}`);
      return Array.isArray(res?.data) ? res.data : [];
    },
    async listMateriaPrimaFamiliaTopHTTP(limit = 20) {
      const qs = getParamsUrl({
        page: 1,
        limit,
        sortBy: 'Descripcion',
        sort: 'asc',
        Activo: true,
      });
      const res = await api.get(`/${this.entity}?${qs}`);
      return Array.isArray(res?.data) ? res.data : [];
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.materiaPrimaFamilias = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
    async firstMateriaPrimaFamilia(params) {
      this.setPage(params.page || 1);
      this.emptyList();
      await this.findAllfamiliaMaterialHTTP(params);
    },
  },
});
